/**
 * NIVORLA premium visual enhancements.
 * This script only toggles visual state classes. It does not intercept
 * navigation, forms, cart events, variant changes, or app integrations.
 */
(() => {
  const root = document.documentElement;
  let ticking = false;

  const updateScrollState = () => {
    root.classList.toggle('nivorla-is-scrolled', window.scrollY > 12);
    ticking = false;
  };

  const requestScrollUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateScrollState);
  };

  updateScrollState();
  window.addEventListener('scroll', requestScrollUpdate, { passive: true });
  document.addEventListener('shopify:section:load', updateScrollState);
})();
